import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const EPPatent = () => {
  const faqs = [
    {
      question: "Q1: What is the EP Patents feature?",
      answer:
        "A: The EP Patent feature lets users retrieve bibliographic details for European Patent (EP) publications. Currently, this feature supports EP patents only.",
    },
    {
      question: "Q2: What input format is supported?",
      answer:
        "A: The feature accepts EP publication numbers only, consisting of 7 digits and a kind code. Example: EP1234567A1, 1234567A1",
    },
    {
      question: "Q3: Can I extract data for multiple jurisdictions at once?",
      answer:
        "A: No. You must select EP Patent and enter publication numbers specific to that jurisdiction only.",
    },
    {
      question: "Q4: How many publication numbers can I enter at once?",
      answer:
        "A: You can enter up to 500 publication numbers on a single request.",
    },
    {
      question: "Q5: What happens if I enter an invalid number?",
       answer: (
            <>
            A: JUNE displays an error message in the UI and sends an email notification:{" "}
            <em>“No data found. Check input and try again.”</em>
            </>
        )
    },
    {
      question: "Q6: How quickly will I get the results?",
      answer:
        "A: In most cases, results are generated instantly and are available for download from the JUNE interface. For larger requests (up to 500 application numbers), processing may take longer, and you will receive an email notification once the file is ready.",
    },
  ];

  return (
    <Box>
      {faqs.map((faq, i) => (
        <Accordion
          key={i}
          defaultExpanded={i === 0}
          sx={{
            backgroundColor: "#fff",
            "&.Mui-expanded": { margin: 0 },
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="body2" fontWeight="bold">
              {faq.question}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography sx={{ whiteSpace: "pre-line" }}>
              {faq.answer}
            </Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

export default EPPatent;
